import { SOCKET_EVENTS } from "../../socket/Events";
import { CHAT_EVENTS } from "../../constants/chat";
import { sceneChat, pvtChat, roomChat } from "./UI/Chat-New";

export const types = {
  ROOM: "ROOM",
  SCENE: "SCENE",
  PRIVATE: "PRIVATE",
  TOUR: "TOUR",
  CHESS: "CHESS",
}

class ChatPanelTitle {
  constructor(data) {
    const { id, img, type, title, lastMessage, timestamp, container, model } = data;
    this.data = data;
    this.type = type || types.ROOM;
    this.model = model;
    if (this.type === types.ROOM) {
      this.wrapper = $(roomChat({
        id,
        img,
        title,
        lastMessage,
        timestamp,
      }));
    }
    if (this.type === types.PRIVATE) {
      this.wrapper = $(pvtChat({
        id,
        img,
        title,
        lastMessage,
        timestamp,
      }));
    }
    if (this.type === types.SCENE) {
      this.wrapper = $(sceneChat({
        id,
        img,
        title,
        lastMessage,
        timestamp,
      }));
    }
    if (this.type === types.CHESS) {
      this.wrapper = $(sceneChat({
        id,
        img,
        title,
        lastMessage,
        timestamp,
      }));
    }

    // Selectors for modifying the chat component dynamically
    this.avatarImage = this.wrapper.find(".avatar img"); // Avatar image
    this.title = this.wrapper.find(".chat-title"); // Chat title
    this.message = this.wrapper.find(".chat-message"); // Last message
    this.timestamp = this.wrapper.find(".chat-time"); // Timestamp
    this.iconWrapper = this.wrapper.find(".icon-wrapper svg"); // SVG icon
    this.notificationBadge = this.wrapper.find(".notification-badge");

    this.initListeners();
    this.setNotificationBagdeNum(0);
    $(container).after(this.wrapper);

  }
  initListeners() {
    this.wrapper.on("click", () => {
      if (this.type === types.ROOM) {
        this.model.dispatchEvent({ type: CHAT_EVENTS.OPEN_WORLD_CHAT, data: { id: this.data.id, type: this.type } })
      }
      if (this.type === types.SCENE) {
        this.model.dispatchEvent({ type: CHAT_EVENTS.OPEN_SCENE_CHAT, data: { id: this.data.id, type: this.type } })
      }
      if (this.type === types.PRIVATE) {
        this.model.dispatchEvent({ type: CHAT_EVENTS.OPEN_ONE_ON_ONE, data: { id: this.data.id, type: this.type } })
      }
      if (this.type === types.CHESS) {
        this.model.dispatchEvent({ type: CHAT_EVENTS.OPEN_CHESS_CHAT, data: { id: this.data.id, type: this.type } })
      }
    });
    if (this.type === types.ROOM) {
      this.model.socket.addEventListener(SOCKET_EVENTS.MESSAGE_RECEIVED, (e) => {
        const { text, senderName } = e.data;
        this.message.html(`${senderName}: ${text}`);
      });
    }
    if (this.type === types.SCENE) {
      this.model.socket.addEventListener(SOCKET_EVENTS.LOCAL_MESSAGE_RECEIVED, (e) => {
        const { text, senderName, sceneId } = e.data;
        if (this.data.id === sceneId) {
          this.message.html(`${senderName}: ${text}`);
        }
      })
    }
    if (this.type === types.PRIVATE) {
      this.model.socket.addEventListener(SOCKET_EVENTS.ONE_ONE_ONE_MESSAGE_RECEIVED, (e) => {
        const { text, senderId, senderName,time } = e.data;
        if (this.data.id == senderId) {
          this.message.html(`${senderName}: ${text}`);
          this.wrapper.attr("last-timestamp", new Date(time).getTime());
        }
      })
    }
  }
  hide() {
    this.wrapper.hide();
  }
  show() {
    this.wrapper.show();
  }
  setNotificationBagdeNum(num) {
    if (this.notificationBadge) {
      this.notificationBadge.show();
      this.notificationBadge.html(num)
      if (num === 0) {
        this.notificationBadge.hide();
      }
    }
  }
}

export default ChatPanelTitle;